module.exports = __webpack_public_path__ + "static/media/07_4.27826281.png";